import { /* React,  */ useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from "polotno";
import { runInAction } from "mobx";
import { EditableText, Tooltip } from "@blueprintjs/core";
import { Toolbar } from "polotno/toolbar/toolbar";
import { Workspace } from "polotno/canvas/workspace";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import FontComponant from "../../../design/FontComponant";
import TimeLineControllers from "./TimeLineControllers";
import CustomPageTimeline from "./CustomPageTimeline";
import { useDispatch, useSelector } from "react-redux";
// import { setDesignStore } from "../../../redux/slices/variationSlice";
import InformationPopup from "../../../popup/InformationPopup";
// import { clearThumb } from "../../../redux/slices/ThumbnailSlice";
import DesignSidebar from "../../../components/DesignSidebar";
import VariationCountLabel from "../../../components/VariationCountLabel";
import {
    /* saveToIndexedDB,  */ getFromIndexedDB,
} from "../../../utils/indexedDB";
import { updateName, updateNum } from "../../../redux/slices/PlanDetailSlice";
import { fetchSizes, setDimensions } from "../../../redux/slices/SizeSlice";
import {
    addExternalText,
    changeDocumentTitle,
    clearGrid,
    getApplyLocalStoreState,
    getCenteredCrop,
    isFitToPageEnabled,
    userID,
} from "../../../utils/helper";
import { PagesTimeline } from "polotno/pages-timeline";
import { BeatLoader } from "react-spinners";
// import { Button } from "@blueprintjs/core";
import CustomeZoombar from "./CustomeZoombar";
// import CustomHeightWidthInfo from "./CustomHeightWidthInfo";
import { setDownScalingEnabled, unstable_setTextOverflow } from "polotno/config";
import { reaction } from "mobx";
import {
    createDesign,
    /*  getDesignDetail, */
    updateDesign,
} from "../../../redux/slices/DesignSlice";
import useDesignData from "../../../hook/useDesignData";
import FigureFitToPage from "../../../components/FigureFitToPageBtn";
import { showToast } from "../../../redux/slices/ToastSlice";
import KEYS from "../../../env/env";
import TextOverflowToggle from "./TextOverFlowToggle";
import { getImageSize } from "polotno/utils/image";
import debounce from "lodash.debounce";
import TextAutoFitToggle from "../../../components/AutofitElemement";
import { useScrubInput } from "../../../hook/useScrubInput";
import { CloudIcon } from "lucide-react";
import InternetSpeedIndicator from "../../../components/InternetSpeedIndicator";


const PolotnoDesignNew = observer(({ store }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    /* const allStates = useSelector((state) => {
    console.log("state is ", state);
  }); */

    const userData = useSelector((state) => state.user.userData);
    const { createdDesignId, isLoading: designIsLoading } = useSelector(
        (state) => state.design
    );
    const userPlanDetails = useSelector((state) => state.userPlan);
    const sizeDimensions = useSelector(
        (state) => state.sizeDimension.dimensions
    );
    const { isLoading, isSizeFetched } = useSelector(
        (state) => state.sizeDimension
    );
    const selectedType = useSelector(
        (state) => state.sizeDimension.selectedType
    );
    const { designThumbs } = useSelector((state) => state.thumbnails);
    const sizes = useSelector((state) => state.sizeDimension.sizes);
    const userId = userID();
    const searchParams = new URLSearchParams(location.search);
    const [sizeFormat, setSizeFormat] = useState("inch");
    const [showTooltip, setShowTooltip] = useState(false);
    const [showTimeLine, setShowTimeline] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [images, setImages] = useState([]);
    const [showSmallThumbs, setShowSmallThumbs] = useState(true);
    const [isBgEditable, setIsBgEditable] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [showInformationPopup, setInformationPopup] = useState(false);
    const [generatingThumb, setGeneratingThumb] = useState(false);
    const [selectedThumbPage, setSelectedThumbPage] = useState("");
    const [preservedImages, setPreservedImages] = useState([]);
    const [activeTab, setActiveTab] = useState("design");
    const [isResetting, setIsResetting] = useState(false);
    const [loading, setLoading] = useState(false);
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const [isExporting, setIsExporting] = useState(false);
    const [applyingChanges, setApplyingChanges] = useState(false);
    const [showingTimeline, setShowingTimeline] = useState(true);
    const [redirectingVariation, setRedirectingVariation] = useState(false);
    const [redirectingExport, setRedirectingExport] = useState(false);
    const [variationAlreadyClicked, setVariationAlreadyClicked] =
        useState(false);
    const [warnPopup, setWarnPopup] = useState(false);
    const [applyAllAlreadyClicked, setApplyallAlreadyClicked] = useState(false);
    const [designName, setDesignName] = useState("");
    const { isLoading: createDesignLoading } = useSelector(
        (state) => state.design
    );
    const { id } = useParams();
    const [applyingToAll, setApplyingToAll] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const [isTextOverFlowOn, setIsTextOverFlowOn] = useState(false);
    // const [autoFitTextEnabled, setAutoFitTextEnabled] = useState(false);



  const [autoFitTextEnabled, setAutoFitTextEnabled] = useState(() => {
    // Load initial value from localStorage
    return localStorage.getItem("autoFitTextEnabled") === "true";
  });

    console.log("size dimensions are: ", sizeDimensions); 


    const setStoreData = async (data) => {
        if (!data || Object.keys(data).length === 0) {
          console.warn("Empty data passed to setStoreData");
          return;
        }
        store.loadJSON(data);
        ensureTextAutoFit(store);

        await store.waitLoading();
        
      };

    // Use the custom hook
    const {
        designInfo,
        isDesignLoading,
        hasDesignData,
        textFieldsNum,
        textFieldsName,
        loadDesignDetail,
        setDesignDataToStore,
        resetDesignData,
    } = useDesignData(store, setStoreData);
    useEffect(() => {
        setRedirectingVariation(createDesignLoading);
    }, [createDesignLoading]);

    useEffect(() => {
        if (designInfo?.design_name) {
            setDesignName(designInfo?.design_name);
            document.title = `${designInfo?.design_name} - Teedex`;
        }
    }, [designInfo]);

    var token = localStorage.getItem("Login");

    const handleDesignRename = async (value) => {
        const response = await fetch(
            KEYS.apiPath + "design/update/" + designInfo?.id,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    design_name: value,
                }),
            }
        );
        const data = await response.json();
        if (+data.resultFlag === 1) {
            changeDocumentTitle(value);
            dispatch(
                showToast({
                    message: "Name Updated successfully",
                })
            );
        }
    };

    const saveDesign = async (
        redirectTo = "variation_page",
        isNavigate = false,
        design_name
    ) => {
        if (isSaving) return;
        setIsSaving(true);
        try {
            setDownScalingEnabled(false);
            let base64 = await store.toDataURL({
                pageId: "master",
                quality: 0.3,
                mimeType: `image/png`,
            });

            // convert to plan base64
            base64 = base64.replace(/^data:image\/\w+;base64,/, "");
            setDownScalingEnabled(true);

            let payload = {
                design_name: design_name || designName || `Design ${new Date().toLocaleDateString()}`,
                store_data: {
                    dimensions: sizeDimensions,
                    store_json: store.toJSON(),
                    selected_type: selectedType,
                    is_player_name_checked: textFieldsName,
                    is_player_number_checked: textFieldsNum,
                    is_apply_to_all_already_clicked: applyAllAlreadyClicked,
                    ...(designInfo?.store_data?.excel_data
                        ? { excel_data: designInfo?.store_data?.excel_data }
                        : {}),
                },
                design_thumbnail: {
                    base64: base64,
                    mimeType: `image/png`,
                },
            };

            payload.redirect_to = redirectTo;

            const designId = id || designInfo?.id || createdDesignId;

            if (designId) {
                if (designInfo && +designInfo?.user_id !== +userData?.id) {
                    const { redirect_to } = payload;
                    if (redirect_to === "variation_page") {
                        if (navigate !== null) {
                            navigate(`/variation/${designId}`);
                        } else {
                            window.location.href = `/variation/${designId}`;
                        }
                    } else if (redirect_to === "export_page") {
                        if (navigate !== null) {
                            navigate(`/export/${designId}`);
                        } else {
                            window.location.href = `/export/${designId}`;
                        }
                    }
                    return;
                }
                await dispatch(
                    updateDesign({
                        id: designId,
                        designData: payload,
                        navigate: isNavigate ? navigate : null,
                    })
                ).unwrap();
            } else {
                payload.size_data = {};
                await dispatch(
                    createDesign({
                        designData: payload,
                        navigate: isNavigate ? navigate : null,
                    })
                ).unwrap();
            }
        } finally {
            setIsSaving(false);
        }
    };



    store.on("change", () => {
        const masterPage = store.pages.find((page) => page.id === "master");

        // console.log("master page ", masterPage?.toJSON());

        const playerName = masterPage?.children?.find(
            (child) => child.id === "master_playernametext"
        );
        const playerNumber = masterPage?.children?.find(
            (child) => child.id === "master_playernumbertext"
        );

        if (!playerName) {
            dispatch(updateName(false));
        }

        if (!playerNumber) {
            dispatch(updateNum(false));
        }
    });

    /*  const hasChanged = (previousState, currentState) => {
    return !deepEqual(previousState, currentState);
  }; */

    const removeAddButton = () => {
        const iconSpan = document.querySelector(".bp5-icon.bp5-icon-plus");

        if (iconSpan) {
            const button = iconSpan.closest("button");
            button.remove();
        }
    };

    /*  const deepEqual = (a, b) => {
    if (a === b) return true;

    if (
      typeof a !== "object" ||
      typeof b !== "object" ||
      a === null ||
      b === null
    )
      return false;

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
      if (!keysB.includes(key)) return false;
      if (!deepEqual(a[key], b[key])) return false;
    }

    return true;
  }; */

    const scrollToTop = () => {
        // Scroll workspace to top
        store.selectPage("master");
        const workspace = document.querySelector(".polotno-workspace");
        if (workspace) {
            workspace.scrollTo({ top: 0, behavior: "instant" });
        }

        const workSpaceInner = document.querySelector(
            ".polotno-workspace-inner"
        );
        if (workSpaceInner) {
            workSpaceInner.scrollTo({ top: 0, behavior: "instant" });
        }
        // Scroll window to top
        window.scrollTo({
            top: 0,
            behavior: "instant",
        });
    };

    useEffect(() => {
        console.log("useEffect 1");

        setTimeout(() => {
            setShowingTimeline(false);
        }, 2000);

        if (
            localStorage.getItem(
                getApplyLocalStoreState(localStorage.getItem("selectedType"))
            )
        ) {
            setApplyallAlreadyClicked(
                localStorage.getItem(
                    getApplyLocalStoreState(
                        localStorage.getItem("selectedType")
                    )
                )
            );
        }
    }, []);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const iconSpan = document.querySelector(".bp5-icon.bp5-icon-plus");
            const button = iconSpan?.closest("button");
            if (button) {
                button.remove();
                observer.disconnect(); // Stop observing once done
            }

            setTimeout(() => {
                const timelineContainer = document?.querySelector(
                    "#timeline-container"
                );
                const spans = timelineContainer?.querySelectorAll(
                    "span.bp5-icon.bp5-icon-more"
                );

                spans?.forEach((span) => {
                    const removeBtn = span?.closest("button");
                    if (removeBtn) {
                        removeBtn.remove();
                    }
                });
            }, 500);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect(); // Cleanup on unmount
    }, []);

    // console.log("store.selectedElements[0]", store.selectedElements[0]);
    useEffect(() => {
        removeAddButton();
    }, []); // runs once on mount

    useEffect(() => {
        // Fetch sizes when component mounts
        if (!isSizeFetched) {
            dispatch(fetchSizes(userId));
        }
    }, [dispatch, isSizeFetched]);

    useEffect(() => {
        if (sizes && sizes?.length > 0 && designInfo?.store_data?.selected_type) {
            // Generate dimensions from fetched sizes
            const dimensions = generateSizeDimensions(sizes);

            let _selectedType = designInfo?.store_data?.selected_type;
            if(_selectedType === undefined || _selectedType === null) {
                _selectedType = localStorage.getItem("selectedType");
            }          
            // Set the dimensions in the reducer
            dispatch(
                setDimensions({
                    selectedType: _selectedType,
                })
            );
        }
        else if(sizes && sizes?.length > 0){

            dispatch(
                setDimensions({
                    selectedType: localStorage.getItem("selectedType")
                })
            )
        }


    }, [sizes, dispatch, designInfo]);


    const handleUnlockClick = () => {
        const activePage = store.activePage;
        if (!activePage) return;

        setIsBgEditable((prev) => {
            runInAction(() => {
                const existingBg = activePage.children.find(
                    (child) => child.name === "background-image"
                );

                if (existingBg) {
                    if (!prev) {
                        // Unlock background (Make draggable & selectable)
                        existingBg.set({
                            selectable: true,
                            evented: true,
                            lockScalingX: false,
                            lockScalingY: false,
                            lockMovementX: false,
                            lockMovementY: false,
                        });
                    } else {
                        // Lock background (Prevent dragging & scaling)
                        existingBg.set({
                            selectable: false,
                            evented: false,
                            lockScalingX: true,
                            lockScalingY: true,
                            lockMovementX: true,
                            lockMovementY: true,
                        });
                    }
                } else {
                    // Convert background to image only if it doesn't exist
                    const bgValue = activePage.background;
                    if (!bgValue || bgValue === "transparent") return;

                    runInAction(() => {
                        activePage.set({ background: "transparent" });

                        activePage.addElement({
                            id: `background-image-${activePage.id}`,
                            name: "background-image",
                            type: "image",
                            src: bgValue,
                            x: 0,
                            y: 0,
                            width: activePage.width,
                            height: activePage.height,
                            selectable: true,
                            evented: true,
                            lockScalingX: false,
                            lockScalingY: false,
                            lockMovementX: false,
                            lockMovementY: false,
                        });
                    });
                }
            });

            return !prev;
        });
    };

    const convertBackgroundToImage = (masterPage, targetPage) => {
        if (!masterPage || !targetPage) return;

        const bgValue = masterPage.background; // Background color or image URL

        // Initially, set the background (locked)
        targetPage.set({ background: bgValue });
    };

    //syncchanges function commented on 23-08-2025 by dpk for logo position error
    // const syncChanges = async (masterPage, targetPage) => {
    //   runInAction(() => {
    //     // console.log('Syncing changes from master page to target page');

    //     // add this code syncing deleted elements
    //     targetPage.set({
    //       background: masterPage.background,
    //       children: [],
    //     });

    //     // 1. Convert master page background to image on target page
    //     convertBackgroundToImage(masterPage, targetPage);

    //     // 2. Create a mapping of target page elements by ID
    //     const targetElementsMap = new Map(
    //       targetPage.children.map((child) => [child.id, child])
    //     );

    //     // 3. Get removed elements from both master and target pages
    //     const removedElements = new Set([
    //       ...(targetPage.custom?.removedElements || []),
    //       ...(masterPage.custom?.removedElements || []),
    //     ]);

    //     console.log('removedElements', removedElements);

    //     // Calculate scaling factors
    //     const scaleX = targetPage.width / masterPage.width;
    //     const scaleY = targetPage.height / masterPage.height;

    //     // 4. Iterate over master page elements
    //     masterPage.children.forEach((masterObject) => {
    //       let masterData = masterObject.toJSON();

    //       // Skip removed elements
    //       if (removedElements.has(masterData.id)) return;

    //       // 5. Generate a unique ID for each master element to sync with the target
    //       const uniqueId = `${masterData.id}-${targetPage.id}`;

    //       // 6. Find corresponding target element
    //       const targetObject = targetElementsMap.get(uniqueId);

    //       // Calculate new position and dimensions based on scaling factors
    //       let newX = masterData.x * scaleX;
    //       let newY = masterData.y * scaleY;
    //       let newWidth = masterData.width * scaleX;
    //       let newHeight = masterData.height * scaleY;
    //       let newFontSize = masterData.fontSize
    //         ? masterData.fontSize * Math.min(scaleX, scaleY)
    //         : undefined;

    //       // Special handling for text elements to maintain aspect ratio based on font size
    //       if (masterData.type === 'text' && newFontSize !== undefined) {
    //         switch (uniqueId) {
    //           case "master_playernumbertext-XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernametext-2XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernumbertext-2XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernametext-3XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernumbertext-3XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernametext-4XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernumbertext-4XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernametext-5XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernumbertext-5XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernametext-6XL":
    //             masterData.width = 1000;
    //             break;
    //           case "master_playernumbertext-6XL":
    //             masterData.width = 1000;
    //             break;
    //           default:
    //             break;
    //         }
    //         // Recalculate width and height based on the new font size
    //         // newWidth = getTextWidth(
    //         //   masterData.text,
    //         //   newFontSize,
    //         //   masterData.fontFamily || 'Arial'
    //         // );
    //         // newHeight = getTextHeight(newFontSize, masterData.lineHeight || 1.2);

    //         // Adjust X position if it was centered on the master page
    //         const relativeX = masterData.x / masterPage.width;
    //         if (relativeX >= 0.05 && relativeX <= 0.55) {
    //           // Center the element horizontally if it's near the center of the master page
    //           newX = (targetPage.width - newWidth) / 2; // Use newWidth for centering
    //         }
    //       } else if (masterData.type === 'image' || masterData.type === 'shape') {
    //         // Add shape type for aspect ratio
    //         // For images and shapes, maintain aspect ratio and fit within the target page
    //         const aspectRatio = masterData.width / masterData.height;

    //         // Calculate potential new dimensions based on both scaling factors
    //         const potentialNewWidth = masterData.width * scaleX;
    //         const potentialNewHeight = masterData.height * scaleY;

    //         // Determine which dimension is the limiting factor and calculate final dimensions
    //         if (potentialNewWidth / aspectRatio > targetPage.height) {
    //           // Height is the limiting factor
    //           newHeight = targetPage.height;
    //           newWidth = newHeight * aspectRatio;
    //         } else if (potentialNewHeight * aspectRatio > targetPage.width) {
    //           // Width is the limiting factor
    //           newWidth = targetPage.width;
    //           newHeight = newWidth / aspectRatio;
    //         } else {
    //           // Both dimensions fit, use scaled dimensions
    //           newWidth = potentialNewWidth;
    //           newHeight = potentialNewHeight;
    //         }

    //         // Adjust X position if it was centered on the master page
    //         const relativeX = masterData.x / masterPage.width;
    //         if (relativeX >= 0.05 && relativeX <= 0.55) {
    //           // Center the element horizontally if it's near the center of the master page
    //           newX = (targetPage.width - newWidth) / 2; // Use newWidth for centering
    //         }
    //         // Adjust Y position if it was centered on the master page
    //         const relativeY = masterData.y / masterPage.height;
    //         if (relativeY >= 0.05 && relativeY <= 0.55) {
    //           newY = (targetPage.height - newHeight) / 2;
    //         }
    //       }

    //       console.log(
    //         `[${masterData.id}] → newX: ${newX}, newY: ${newY}, newWidth: ${newWidth}, newHeight: ${newHeight}, newFontSize: ${newFontSize}`
    //       );

    //       // 10. Update or create target element
    //       if (targetObject) {
    //         // Update existing target element with master data
    //         const updatedObject = {
    //           ...masterData,
    //           align: masterData.align, // Keep original alignment
    //           id: targetObject.id, // Use targetObject's ID
    //           x: newX, // Use the calculated newX
    //           y: newY, // Use the calculated newY
    //           width: newWidth,
    //           height: newHeight,
    //           fontSize: newFontSize, // Use the calculated newFontSize
    //         };
    //         targetObject.set(updatedObject);
    //       } else {
    //         // Add new element to target page if it doesn't exist
    //         const newObject = {
    //           ...masterData,
    //           align: masterData.align, // Keep original alignment
    //           id: uniqueId,
    //           x: newX, // Use the calculated newX
    //           y: newY, // Use the calculated newY
    //           width: newWidth,
    //           height: newHeight,
    //           fontSize: newFontSize, // Use the calculated newFontSize
    //         };
    //         targetPage.addElement(newObject);
    //       }
    //     });
    //   });

    //   // After syncing, save the updated state as JSON
    //   // setStoreJson(JSON.stringify(store.toJSON()));
    // };

    // in below syncchanges function, logo is not cutting, just logo slides a bit

    //  const syncChanges = async (masterPage, targetPage) => {
    //   runInAction(() => {
    //     // Reset background and children
    //     targetPage.set({
    //       background: masterPage.background,
    //       children: [],
    //     });

    //     convertBackgroundToImage(masterPage, targetPage);

    //     const removedElements = new Set([
    //       ...(targetPage.custom?.removedElements || []),
    //       ...(masterPage.custom?.removedElements || []),
    //     ]);

    //     const scaleX = targetPage.width / masterPage.width;
    //     const scaleY = targetPage.height / masterPage.height;
    //     const margin = 10; // avoid edge clipping

    //     masterPage.children.forEach((masterObject) => {
    //       const masterData = masterObject.toJSON();

    //       if (removedElements.has(masterData.id)) return;

    //       const uniqueId = `${masterData.id}-${targetPage.id}`;

    //       // Calculate relative position and size
    //       const relX = masterData.x / masterPage.width;
    //       const relY = masterData.y / masterPage.height;
    //       const relW = masterData.width / masterPage.width;
    //       const relH = masterData.height / masterPage.height;

    //       let newWidth = relW * targetPage.width;
    //       let newHeight = relH * targetPage.height;
    //       let newX = relX * targetPage.width;
    //       let newY = relY * targetPage.height;
    //       let newFontSize =
    //         masterData.fontSize &&
    //         masterData.fontSize * Math.min(scaleX, scaleY);

    //       if (masterData.type === "image" || masterData.type === "shape") {
    //         // Maintain aspect ratio
    //         const originalAR = masterData.width / masterData.height;
    //         const targetAR = targetPage.width / targetPage.height;

    //         // Resize proportionally based on master dimensions
    //         const scale = Math.min(scaleX, scaleY);
    //         newWidth = masterData.width * scale;
    //         newHeight = masterData.height * scale;

    //         // Compute position again relatively
    //         newX = masterData.x * scale;
    //         newY = masterData.y * scale;

    //         // Make sure it's not out of bounds
    //         if (newX + newWidth > targetPage.width) {
    //           newX = targetPage.width - newWidth - margin;
    //         }
    //         if (newY + newHeight > targetPage.height) {
    //           newY = targetPage.height - newHeight - margin;
    //         }

    //         // Prevent negative
    //         newX = Math.max(newX, margin);
    //         newY = Math.max(newY, margin);
    //       }

    //       // Handle centered text alignment
    //       if (masterData.type === "text") {
    //         const relativeX = masterData.x / masterPage.width;
    //         if (relativeX >= 0.05 && relativeX <= 0.55) {
    //           newX = (targetPage.width - newWidth) / 2;
    //         }

    //         const relativeY = masterData.y / masterPage.height;
    //         if (relativeY >= 0.05 && relativeY <= 0.55) {
    //           newY = (targetPage.height - newHeight) / 2;
    //         }

    //         // Optional: static width for known labels
    //         if (
    //           uniqueId.includes("playername") ||
    //           uniqueId.includes("playernumber")
    //         ) {
    //           newWidth = 1000;
    //         }
    //       }

    //       const newObject = {
    //         ...masterData,
    //         id: uniqueId,
    //         x: newX,
    //         y: newY,
    //         width: newWidth,
    //         height: newHeight,
    //         fontSize: newFontSize || masterData.fontSize,
    //         align: masterData.align,
    //       };

    //       targetPage.addElement(newObject);
    //     });
    //   });
    // };

    //below sync change function is the best among all
    // const syncChanges = async (masterPage, targetPage) => {
    //   runInAction(() => {
    //     // Reset page
    //     targetPage.set({
    //       background: masterPage.background,
    //       children: [],
    //     });
    //     convertBackgroundToImage(masterPage, targetPage);

    //     const removedElements = new Set([
    //       ...(targetPage.custom?.removedElements || []),
    //       ...(masterPage.custom?.removedElements || []),
    //     ]);

    //     const scaleX = targetPage.width / masterPage.width;
    //     const scaleY = targetPage.height / masterPage.height;
    //     const margin = 10;

    //     masterPage.children.forEach((masterObject) => {
    //       const masterData = masterObject.toJSON();
    //       if (removedElements.has(masterData.id)) return;

    //       const uniqueId = `${masterData.id}-${targetPage.id}`;
    //       const relX = masterData.x / masterPage.width;
    //       const relY = masterData.y / masterPage.height;

    //       let newScale = Math.min(scaleX, scaleY);
    //       let newWidth = masterData.width * newScale;
    //       let newHeight = masterData.height * newScale;

    //       let newX = masterData.x * newScale;
    //       let newY = masterData.y * newScale;

    //       // If centered in master, center in target
    //       if (relX >= 0.45 && relX <= 0.55) {
    //         newX = (targetPage.width - newWidth) / 2;
    //       }
    //       if (relY >= 0.45 && relY <= 0.55) {
    //         newY = (targetPage.height - newHeight) / 2;
    //       }

    //       // Clamp within bounds
    //       if (newX + newWidth > targetPage.width - margin) {
    //         newX = targetPage.width - newWidth - margin;
    //       }
    //       if (newY + newHeight > targetPage.height - margin) {
    //         newY = targetPage.height - newHeight - margin;
    //       }
    //       newX = Math.max(newX, margin);
    //       newY = Math.max(newY, margin);

    //       targetPage.addElement({
    //   ...masterData,
    //   id: uniqueId,
    //   x: newX,
    //   y: newY,
    //   width: newWidth,
    //   height: newHeight,
    //   fontSize: masterData.fontSize ? masterData.fontSize * newScale : undefined,
    //   align: masterData.align,
    // });

    //     });
    //   });
    // };

    const syncChanges = async (masterPage, targetPage) => {
        runInAction(() => {
            // Reset target page
            targetPage.set({
                background: masterPage.background,
                children: [],
            });

            convertBackgroundToImage(masterPage, targetPage);

            const removedElements = new Set([
                ...(targetPage.custom?.removedElements || []),
                ...(masterPage.custom?.removedElements || []),
            ]);            

            const margin = 10;
            
            masterPage.children.forEach(async (masterObject) => {
                const masterData = masterObject.toJSON();
                if (removedElements.has(masterData.id)) return;

                const uniqueId = `${masterData.id}-${targetPage.id}`;

                // Relative positioning and size
                const relX = masterData.x / masterPage.width;
                const relY = masterData.y / masterPage.height;
                const relWidth = masterData.width / masterPage.width;
                const relHeight = masterData.height / masterPage.height;

                // Absolute target values
                let newWidth = targetPage.width * relWidth;
                let newHeight = targetPage.height * relHeight;
                let newX = targetPage.width * relX;
                let newY = targetPage.height * relY;

                // Maintain aspect ratio for images/shapes
                // commenting below code for now
                // if (masterData.type === "image" || masterData.type === "shape") {
                //   const aspectRatio = masterData.width / masterData.height;

                //   // Adjust width and height to preserve aspect ratio
                //   const scaledWidth = targetPage.width * relWidth;
                //   const scaledHeight = targetPage.height * relHeight;

                //   if (scaledWidth / aspectRatio > targetPage.height) {
                //     newHeight = targetPage.height * relHeight;
                //     newWidth = newHeight * aspectRatio;
                //   } else {
                //     newWidth = targetPage.width * relWidth;
                //     newHeight = newWidth / aspectRatio;
                //   }

                //   // Recalculate X/Y based on aspect-adjusted size
                //   newX = targetPage.width * relX;
                //   newY = targetPage.height * relY;
                // }

                //and updating code with this
                // Stretch image if stretchEnabled is true
                if (masterData.type === "image" && masterData.stretchEnabled) {
                    newWidth = targetPage.width;
                    newHeight = targetPage.height;
                    newX = 0;
                    newY = 0;
                } else if (
                    masterData.type === "image" ||
                    masterData.type === "shape"
                ) {
                    const aspectRatio = masterData.width / masterData.height;

                    const scaledWidth = targetPage.width * relWidth;
                    const scaledHeight = targetPage.height * relHeight;

                    if (scaledWidth / aspectRatio > targetPage.height) {
                        newHeight = targetPage.height * relHeight;
                        newWidth = newHeight * aspectRatio;
                    } else {
                        newWidth = targetPage.width * relWidth;
                        newHeight = newWidth / aspectRatio;
                    }

                    newX = targetPage.width * relX;
                    newY = targetPage.height * relY;
                }

                // Clamp within bounds
                // if (newX + newWidth > targetPage.width - margin) {
                //   newX = targetPage.width - newWidth - margin;
                // }
                // if (newY + newHeight > targetPage.height - margin) {
                //   newY = targetPage.height - newHeight - margin;
                // }
                // newX = Math.max(newX, margin);
                // newY = Math.max(newY, margin); line 889-896 commented for stretch by deepak and replace with below code

                // Skip clamping if it's a stretched image (we want full edge-to-edge)
                if (
                    !(masterData.type === "image" && masterData.stretchEnabled)
                ) {
                    if (newX + newWidth > targetPage.width - margin) {
                        newX = targetPage.width - newWidth - margin;
                    }
                    if (newY + newHeight > targetPage.height - margin) {
                        newY = targetPage.height - newHeight - margin;
                    }
                    newX = Math.max(newX, margin);
                    newY = Math.max(newY, margin);
                }

                // Font size (for text only)
                const newScale = Math.min(
                    targetPage.width / masterPage.width,
                    targetPage.height / masterPage.height
                );
                const newFontSize = masterData.fontSize
                    ? masterData.fontSize * newScale
                    : undefined;

                const fitToPageEnabled = isFitToPageEnabled(masterPage, masterData);
                let cropForFitToPage = {}
                if(fitToPageEnabled && !masterData.stretchEnabled){
                    if(masterData.type === 'image'){
                        const { width, height } = await getImageSize(masterData.src);
                        cropForFitToPage = getCenteredCrop(width, height, targetPage.width, targetPage.height)
                    }
                    newX = 0
                    newY = 0
                    newWidth = targetPage.width
                    newHeight = targetPage.height 
                }

                targetPage.addElement({
                    ...masterData,
                    id: uniqueId,
                    x: newX,
                    y: newY,
                    width: newWidth,
                    height: newHeight,
                    fontSize: newFontSize,
                    align: masterData.align,
                    ...(fitToPageEnabled && cropForFitToPage)
                });

                // to fix the image being render on top when fit to page is abled
                if(fitToPageEnabled && masterData.type === 'image'){
                    targetPage.moveElementBottom(uniqueId)
                }
            });
        });
    };

    const resetHandlerV2 = async () => {
        try {
            store.pages.forEach((page) => {
                page.set({
                    background: "rgba(0,0,0,0)",
                    children: [],
                });
            });
            store.selectPage("master");
            scrollToTop();
        } catch (error) {
            console.error("error in resetHandlerV2", error);
        }
    };

    /*  const resetHandler = async () => {
    try {
      setIsResetting(true);
      setGeneratingThumb(true);
      if (sizeDimensions && sizeDimensions?.M) {
        store.clear();
        const dpi = 72;

        // Create master page first
        store.addPage({
          name: "master",
          width: sizeDimensions.M.inchWidth * dpi,
          height: sizeDimensions.M.inchHeight * dpi,
          id: "master",
          background: "rgba(0,0,0,0)",
          custom: {
            size: "M",
            inch: sizeDimensions["M"]?.inch,
            pixels: `${sizeDimensions["M"]?.width} X ${sizeDimensions["M"]?.height} px`,
          },
        });

        dispatch(updateName(false));
        dispatch(updateNum(false));

        Object.keys(sizeDimensions)?.forEach((size) => {
          if (size !== "master") {
            // Skip master size since it's already created
            const item = sizeDimensions[size];
            store.addPage({
              name: size.split(" ").join("_"),
              width: item.inchWidth * 72,
              height: item.inchHeight * 72,
              id: size.split(" ").join("_"),
              background: "rgba(0,0,0,0)",
              custom: {
                size: size,
                inch: item?.inch,
                pixels: `${item?.width} X ${item?.height}`,
              },
            });
          }
        });

        // Process pages after all are added
        // commented on 8 May 2025 11:46 PM
        // await processAllPages();

        // Select master page immediately
        store.selectPage("master");

        // Force scroll to top after everything is done
        const workspace = document.querySelector(".polotno-workspace");
        if (workspace) {
          workspace.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    } catch (error) {
      // console.log('reset canvas error ', error);
    } finally {
      setGeneratingThumb(false);
      setIsResetting(false);
    }
  }; */

    const refreshHandler = async () => {
        setApplyingToAll(true);
        setApplyallAlreadyClicked(true);
        localStorage.setItem(
            getApplyLocalStoreState(localStorage.getItem("selectedType")),
            true
        );
        setGeneratingThumb(true);
        setIsChanged(true);
        const masterPage = store.pages.find((page) => page.id === "master");
        store.pages.forEach(async (page) => {
            if (page.id !== "master") {
                const arr = [page];
                await Promise.all(
                    arr.map(async (item) => {
                        try {
                            await syncChanges(masterPage, item);

                            item.set({
                                custom: {
                                    ...(item.custom || {}),
                                    textAutoFitEnabled: masterPage.custom?.textAutoFitEnabled ?? true,
                                },
                            });
    
                        } catch (error) {
                            console.log("error is", error);
                        }
                    })
                );
                await sleep(50);
            }
        });

        await saveDesign(null, false);
        setApplyingToAll(false);
    };

    const sizeChangeHandler = (e) => {
        const val = e.target.value;
        setSizeFormat(val);
        store.setUnit({
            unit: val === "inch" ? "in" : "px",
            dpi: 72,
        });
    };

    const handlePageClick = (id) => {
        setShowTimeline((prev) => !prev);
        setShowSmallThumbs(true);
        setSelectedThumbPage(id);
    };
    const TextAiWrite = () => null;

    const customFontFamily = () => <FontComponant store={store} />;
    const smallThumbHandler = () => setShowSmallThumbs((prev) => !prev);
    const timlineHandler = () => {
        setShowTimeline((prev) => !prev);
        setShowSmallThumbs(false);
    };

    const navigateToVariation = async () => {
        await saveDesign("variation_page");
    };

    const handleVariationClick = async () => {
        if (
            selectedType === "a4" ||
            selectedType === "a3" ||
            selectedType === "a2" ||
            selectedType === "a1" ||
            selectedType === "custom"
        ) {
            await navigateToVariation();
            return;
        }

        if (id) {
            let isApplyToAllAlreadyClicked =
                store.activePage.custom?.is_apply_to_all_already_clicked;

            if (!isApplyToAllAlreadyClicked) {
                isApplyToAllAlreadyClicked =
                    designInfo?.store_data?.is_apply_to_all_already_clicked ||
                    false;

                if (!isApplyToAllAlreadyClicked) {
                    const storePage = store.pages[1].toJSON();
                    if (storePage.children.length > 0) {
                        isApplyToAllAlreadyClicked = true;
                    }
                }
            }

            if (isApplyToAllAlreadyClicked) {
                await navigateToVariation();
                return false;
            }
        }

        clearGrid(store);
        if (warnPopup) {
            setApplyallAlreadyClicked(true);
            localStorage.setItem(
                getApplyLocalStoreState(localStorage.getItem("selectedType")),
                true
            );
        } else {
            if (!applyAllAlreadyClicked) {
                setWarnPopup(true);
                return;
            }
        }

        await navigateToVariation();
    };

    const handleExportClick = async () => {
        try {
            setRedirectingExport(true);
            // setIsExporting(true);
            // const variation = localStorage.getItem("tshirtDetails");
            const variations = designInfo?.size_data?.sizes;
            if (variations?.length > 0) {
                // window.location.href = `/export/${id}`;
                await saveDesign("export_page");
                // const storeData = store.toJSON();
                // dispatch(setDesignStore(JSON.stringify(storeData)));
                // setIsExporting(false);

                // setTimeout(() => {
                //   setRedirectingExport(false);

                //   navigate("/export", {
                //     state: {
                //       storeVal: JSON.stringify(storeData),
                //       // isChanged: isChanged,
                //       isChanged: true,
                //       from: "design",
                //     },
                //   });

                // }, 3000);
            } else {
                setInformationPopup(true);
                // setIsExporting(false);
            }
        } catch (error) {
            // setIsExporting(false);
            // console.log('error in export click', error);
        } finally {
            // setIsExporting(false);
            setRedirectingExport(false);
        }
    };

    /*  const TextAlertButton = observer(({ store, element, elements }) => {
    return (
      <button
        onClick={() => {
          alert("Hello!");
        }}
      >
        Alert
      </button>
    );
  }); */

    const ImageSetBackgroundButton = observer(
        ({ store, element, elements }) => {
            return (
                <button
                    className="bp5-button bp5-minimal"
                    onClick={async () => {
                        const imageSrc = element.src;
                        const imageElementId = element.id;

                        // element.set({
                        //   stretchEnabled: true
                        // });

                        const currentPage = store.activePage;
                        if (!currentPage) return;
                        const filterChildren = currentPage.children.filter(
                            (child) => child.id !== imageElementId
                        );
                        currentPage.set({
                            background: imageSrc,
                            children: filterChildren,
                        });
                    }}
                >
                    Set Background
                </button>
            );
        }
    );

    const ImageStretch = observer(({ store, element, elements }) => {
        const obj = {
            color: element.stretchEnabled ? "#2A1FB3" : "black",
            backgroundColor: element.stretchEnabled ? "#E4E2FF" : "white",
        };
        return (
            <button
                style={obj}
                className="bp5-button bp5-minimal"
                onClick={async () => {
                    element.set({
                        stretchEnabled: !element.stretchEnabled,
                    });
                }}
            >
                {!element.stretchEnabled ? "Stretch" : "Unstretch"}
            </button>
        );
    });

    const TextUpperCaseButton = observer(({ store, element, elements }) => {

        const textElement = element;
        const isUpperCase = !textElement.custom?.isUpperCase;
        const isLowerCase = !isUpperCase;

        return (
            <button
                className="bp5-button bp5-minimal"
                style={{
                    background: !isUpperCase ? "lightgrey" :  "none"
                }}
                onClick={async () => {
                    textElement.set({
                        text: isUpperCase
                            ? textElement.text.toUpperCase()
                            : textElement.text.toLowerCase(),
                        custom: {
                            ...textElement.custom,
                            isUpperCase: isUpperCase,
                            isLowerCase: isLowerCase,
                        },
                    });
                }}
            >
                Aa
            </button>
        );
    });

    // const TextInfo = observer(({ store, element, elements }) => {
    //   // const selected = store.selectedElements;

    //   // const element = selected[0]; // assuming single selection

    //   const widthPixels = Math.round(element?.width);
    //   const heightPixels = Math.round(element?.height);

    //   const DPI = 72; // your specified DPI

    //   const widthInches = (widthPixels / DPI).toFixed(1);
    //   const heightInches = (heightPixels / DPI).toFixed(1);

    //   if (element) {
    //     return (
    //       // <div style={{border: "1px solid #cfd8e7", padding: "5px", borderRadius: "5px"}}>
    //       <div>
    //         {sizeFormat === "inch" ? (
    //           <>
    //             {/* <div>W: {widthInches} in</div>
    //             <div>H: {heightInches} in</div> */}

    //             <button className="bp5-button bp5-minimal">
    //               W: {widthInches} in
    //             </button>
    //             <button className="bp5-button bp5-minimal">
    //               H: {heightInches} in
    //             </button>
    //           </>
    //         ) : (
    //           <>
    //             {" "}
    //             {/* <div>W: {widthPixels} pixels</div>
    //             <div>H: {heightPixels} pixels</div> */}
    //             <button className="bp5-button bp5-minimal">
    //               W: {widthPixels} px
    //             </button>
    //             <button className="bp5-button bp5-minimal">
    //               H: {heightPixels} px
    //             </button>
    //           </>
    //         )}
    //       </div>
    //     );
    //   } else {
    //     return <></>;
    //   }
    // });



    const SizeControls = observer(({ store }) => {
        const el = store.selectedElements[0];
        const DPI = 72;
      
        const [widthInput, setWidthInput] = useState("");
        const [heightInput, setHeightInput] = useState("");
      
        if (!el) return null;
      
        console.log("size contorls")
        useEffect(() => {
          setWidthInput(
            sizeFormat === "inch" ? (el.width / DPI).toFixed(1) : el.width.toFixed(1)
          );
          setHeightInput(
            sizeFormat === "inch" ? (el.height / DPI).toFixed(1) : el.height.toFixed(1)
          );
        }, [el, el.width, el.height, sizeFormat]);
      
        const commitWidth = () => {
          const value = parseFloat(widthInput);
          if (isNaN(value)) return;
          const px = sizeFormat === "inch" ? value * DPI : value;
          el.set({ width: px });
        };
      
        const commitHeight = () => {
          const value = parseFloat(heightInput);
          if (isNaN(value)) return;
          const px = sizeFormat === "inch" ? value * DPI : value;
          el.set({ height: px });
        };

        const widthScrub = useScrubInput({
            value: widthInput,
            step: sizeFormat === "inch" ? 0.02 : 1,
            onChange: setWidthInput,
            onCommit: (v) =>
              el.set({ width: sizeFormat === "inch" ? v * DPI : v }),
          });
          
          const heightScrub = useScrubInput({
            value: heightInput,
            step: sizeFormat === "inch" ? 0.02 : 1,
            onChange: setHeightInput,
            onCommit: (v) =>
              el.set({ height: sizeFormat === "inch" ? v * DPI : v }),
          });
          
          
          
      
        useEffect(() => {
          const timer = setTimeout(commitWidth, 600);
          return () => clearTimeout(timer);
        }, [widthInput]);
      
        useEffect(() => {
          const timer = setTimeout(commitHeight, 600);
          return () => clearTimeout(timer);
        }, [heightInput]);
      
        return (
          <div style={{display: "flex", gap: "10px"}}>
            <div className="size-control-container"   style={{
                 border: "1px solid #cfd8e7",
                 borderRadius: "5px",
                 padding: "5px"
                }}>
              <span>W</span>
              <input
                type="number"
                step="0.1"
                value={widthInput}
                onChange={(e) => setWidthInput(e.target.value)}
                onMouseDown={widthScrub.onMouseDown}
                onBlur={() => {
                    if (!widthScrub.isDragging.current) {
                      commitWidth();
                    }
                  }}
                className="size-control-input"
              />
              <span>{sizeFormat === "inch" ? "in" : "px"}</span>
            </div>
            <div    
                style={{
                        border: "1px solid #cfd8e7",
                        borderRadius: "5px",
                        padding: "5px"
                    }} 
                    className="size-control-container">
              <span>H</span>
              <input
                type="number"
                step="0.1"
                value={heightInput}
                onChange={(e) => setHeightInput(e.target.value)}
                onMouseDown={heightScrub.onMouseDown}
                onBlur={() => {
                    if (!heightScrub.isDragging.current) {
                      commitHeight();
                    }
                  }}
                // style={{ width: "50px",     
                //     outline: "none",       
                //     border: "1px solid #ccc",
                //     borderRadius: "3px",
                //     padding: "2px 4px",
                //     cursor: "ew-resize",
              
                // }}
                className="size-control-input"
              />
              <span>{sizeFormat === "inch" ? "in" : "px"}</span>
            </div>
          </div>
        );
      });
      
      
 
    // const TextAutoFitPerElement = observer(({ store }) => {
    //     const element = store.selectedElements[0];
      
    //     // Show button only for single selected text element (not curved)
    //     if (
    //       !element ||
    //       store.selectedElements.length !== 1 ||
    //       element.type !== "text" ||
    //       element.curveEnabled
    //     ) {
    //       return null;
    //     }
      
    //     // Initialize autoFit to true if not set
    //     if (element.custom?.autoFit === undefined) {
    //       element.set({
    //         custom: {
    //           ...element.custom,
    //           autoFit: true,
    //         },
    //       });
    //     }
      
    //     const isAutoFit = !!element.custom?.autoFit;
      
    //     const toggle = () => {
    //       const next = !isAutoFit;
      
    //       element.set({
    //         custom: {
    //           ...element.custom,
    //           autoFit: next,
    //         },
    //       });
      
    //       // Only trigger resize if turning ON
    //       if (next) {
    //         applyAutoFitIfEnabled(element);
    //       }

    //     };

    //     const buttonStyle = {
    //       color: isAutoFit ? "#2A1FB3" : "black",
    //       backgroundColor: isAutoFit ? "#E4E2FF" : "white",
    //       borderRadius: "4px",
    //       fontSize: ".729vw",
    //       fontWeight: 500,
    //       padding: "4px 8px",
    //       border: "none",
    //       cursor: "pointer",
    //     };
      
    //     return (
    //       <button className="bp5-button bp5-minimal" onClick={toggle} style={buttonStyle}>
    //         {isAutoFit ? "Auto-Fit ON" : "Auto-Fit OFF"}
    //       </button>
    //     );
    //   });


    console.log('separation')

    const initialLoadPages = () => {
         if (store.pages.length > 0) return;
        if (selectedType) {
            if (
                selectedType !== "a4" &&
                selectedType !== "a3" &&
                selectedType !== "a2" &&
                selectedType !== "a1" &&
                selectedType !== "custom"
            ) {
                if (sizeDimensions && sizeDimensions?.M) {
                    store.clear();
                    const dpi = 72;

                    const masterPageSize = {
                        back: {
                            width: 21,
                            height: 29,
                            inch: "21 x 29 in",
                        },
                        fullSleeves: {
                            width: 17.5,
                            height: 25,
                            inch: "17.5 x 25 in",
                        },
                        halfSleeves: {
                            width: 17.5,
                            height: 10.5,
                            inch: "17.5 x 10.5 in",
                        },
                    };

                    const masterPage = store.addPage({
                        name: "master",
                        width: masterPageSize[selectedType].width * dpi,
                        height: masterPageSize[selectedType].height * dpi,
                        id: "master",
                        background: "rgba(0,0,0,0)",
                        custom: {
                            size: "M",
                            inch: masterPageSize[selectedType]?.inch,
                            pixels: `${masterPageSize[selectedType]?.width} X ${masterPageSize[selectedType]?.height} px`,
                        },
                    });


                    Object.keys(sizeDimensions)?.forEach((size) => {
                        const item = sizeDimensions[size];
                        store.addPage({
                            name: size.split(" ").join("_"),
                            width: item.inchWidth * 72,
                            height: item.inchHeight * 72,
                            id: size.split(" ").join("_"),
                            background: "rgba(0,0,0,0)",
                            custom: {
                                size: size,
                                inch: sizeDimensions[size]?.inch,
                                pixels: `${sizeDimensions[size]?.width} X ${sizeDimensions[size]?.height}`,
                            },
                        });
                    });

                    store.selectPage("master");

                    const boardType = searchParams.get("boardType");

                    if (boardType === "new") {
                        if (
                            designThumbs &&
                            designThumbs?.length > 0 &&
                            !designThumbs[0]?.image
                        ) {
                            // commented on 8 May 2025 11:46 PM
                            // processAllPages();
                        }
                    }

                    setTimeout(() => {
                        scrollToTop();
                    }, 500);

                    setTimeout(() => {
                        scrollToTop();
                    }, 1000);
                }
            } else {
                let masterPage = store?.pages?.find(
                    (page) => page.id === "master"
                );

                if (!masterPage) {
                    let pageConfig = {
                        width: 3600,
                        height: 2100,
                        size: "a4",
                        inchWidth: 8.3,
                        inchHeight: 11.7,
                        inch: "8.3 x 11.7 in",
                    };

                    if (selectedType === "a3") {
                        pageConfig = {
                            width: 5060,
                            height: 7140,
                            size: "a3",
                            inchWidth: "25.7",
                            inchHeight: "36.3",
                            inch: "25.7 x 36.3 in",
                        };
                    }

                    if (selectedType === "a2") {
                        pageConfig = {
                            width: 7140,
                            height: 10130,
                            size: "a2",
                            inchWidth: "36.3",
                            inchHeight: "51.5",
                            inch: "36.3 x 51.5 in",
                        };
                    }

                    if (selectedType === "a1") {
                        pageConfig = {
                            width: 10130,
                            height: 14320,
                            size: "a1",
                            inchWidth: "51.5",
                            inchHeight: "72.8",
                            inch: "51.5 x 72.8 in",
                        };
                    }

                    if (selectedType === "custom") {
                        pageConfig = {
                            width:
                                parseFloat(
                                    localStorage.getItem("customWidth")
                                ) * 72,
                            height:
                                parseFloat(
                                    localStorage.getItem("customHeight")
                                ) * 72,
                            size: "custom",
                            inchWidth: localStorage.getItem("customWidth"),
                            inchHeight: localStorage.getItem("customHeight"),
                            inch: `${localStorage.getItem(
                                "customWidth"
                            )} X ${localStorage.getItem("customHeight")} in`,
                        };
                    }

                    const dpi = 72;
                    masterPage = store.addPage({
                        name: "master",
                        width: pageConfig.inchWidth * dpi,
                        height: pageConfig.inchHeight * dpi,
                        id: "master",
                        background: "rgba(0,0,0,0)",
                        custom: {
                            size: pageConfig.size,
                            inch: pageConfig.inch,
                            pixels: `${pageConfig.width} X ${pageConfig.height} px`,
                        },
                    });

                    const workspace =
                        document.querySelector(".polotno-workspace");
                    if (workspace) {
                        workspace.scrollTo({ top: 0, behavior: "smooth" });
                    }
                }
            }
        } else {
            // alert("Please select the Artboard first!");
            // navigate("/Home");
        }
    };


    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "Alt") {
                e.preventDefault();
                setShowTooltip(e.type === "keydown");
            }
        };

        const handleShortcut = (e) => {
            const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
            const ctrlOrCmd = isMac ? e.metaKey : e.ctrlKey;
            const isTyping =
                e.target.tagName === "INPUT" ||
                e.target.tagName === "TEXTAREA" ||
                e.target.isContentEditable;

            if (
                !isTyping &&
                e.key.toLowerCase() === "t" &&
                !e.ctrlKey &&
                !e.metaKey &&
                !e.altKey &&
                !e.shiftKey
            ) {
                e.preventDefault();
                addExternalText(store);
            }

            if (e.key.toLowerCase() === "i") {
                console.log("enter i");
            }

            if (ctrlOrCmd && e.key.toLowerCase() === "/") {
                if (store.openedSidePanel !== "") {
                    console.log("store.openSidePanel call 3");
                    store.openSidePanel();
                } else {
                    console.log("store.openSidePanel call 4");
                    store.openSidePanel(
                        store.previousOpenedSidePanel || "custom-text"
                    );
                }
            }

            console.log("e.keye.keye.key", e.key);
            if (ctrlOrCmd && (e.key === "+" || e.key === "=")) {
                e.preventDefault();
                const getSliderValueFromScale = (scale) => {
                    if (scale <= 1) {
                        return scale;
                    } else {
                        return 1 + (scale - 1) / 4;
                    }
                };
                const getActualScale = (sliderValue) => {
                    if (sliderValue <= 1) {
                        return sliderValue; // 0 to 1 maps to 0–1
                    } else {
                        return 1 + (sliderValue - 1) * 4; // 1 to 2 maps to 1–5
                    }
                };
                const currentSliderValue = getSliderValueFromScale(store.scale);
                let val = currentSliderValue + 0.01;
                const sliderValue = parseFloat(val);
                const actualScale = getActualScale(sliderValue);
                store.setScale(actualScale);
            }
            if (ctrlOrCmd && (e.key === "-" || e.key === "_")) {
                e.preventDefault();
                const getSliderValueFromScale = (scale) => {
                    if (scale <= 1) {
                        return scale;
                    } else {
                        return 1 + (scale - 1) / 4;
                    }
                };
                const getActualScale = (sliderValue) => {
                    if (sliderValue <= 1) {
                        return sliderValue; // 0 to 1 maps to 0–1
                    } else {
                        return 1 + (sliderValue - 1) * 4; // 1 to 2 maps to 1–5
                    }
                };
                const currentSliderValue = getSliderValueFromScale(store.scale);
                let val = currentSliderValue - 0.01;
                const sliderValue = parseFloat(val);
                const actualScale = getActualScale(sliderValue);
                store.setScale(actualScale);
            }

            if (
                !isTyping &&
                e.key.toLowerCase() === "r" &&
                !e.ctrlKey &&
                !e.metaKey &&
                !e.altKey &&
                !e.shiftKey
            ) {
                e.preventDefault();
                const page = store.activePage;
                page.addElement({
                    type: "figure",
                    subType: "rect", // ✅ Must be 'shape', not 'rect'
                    name: "custom-square",
                    x: 100,
                    y: 100,
                    width: 300,
                    height: 300,
                    fill: "blue",
                    stroke: "black",
                    strokeWidth: 1,
                    radius: 0, // for rounded corners (optional)
                });
            }

            if (
                !isTyping &&
                e.key.toLowerCase() === "c" &&
                !e.ctrlKey &&
                !e.metaKey &&
                !e.altKey &&
                !e.shiftKey
            ) {
                e.preventDefault();
                const page = store.activePage;
                page.addElement({
                    type: "figure",
                    subType: "circle", // Specify circle as subtype
                    name: "custom-circle",
                    width: 300,
                    height: 300,
                    x: 50, // X position
                    y: 50, // Y position
                    radius: 50, // Radius for the circle
                    fill: "black", // Fill color
                });
            }

            if (
                !isTyping &&
                e.key.toLowerCase() === "l" &&
                !e.ctrlKey &&
                !e.metaKey &&
                !e.altKey &&
                !e.shiftKey
            ) {
                e.preventDefault();
                const page = store.activePage;
                page.addElement({
                    type: "line",
                    name: "custom-line",
                    x: 200, // canvas X position
                    y: 200, // canvas Y position
                    stroke: "black", // Line color
                    strokeWidth: 2, // Thickness of the line
                });
            }

            // else if (e.shiftKey && e.key.toLowerCase() === "t") {
            //   console.log('shift + t click')
            //   addExternalText(store)
            // }
        };

        const handleCombined = (e) => {
            handleKey(e); // Call first function
            handleShortcut(e); // Call second function
        };

        document.addEventListener("keydown", handleCombined, true);
        document.addEventListener("keyup", handleKey, true);

        return () => {
            document.removeEventListener("keydown", handleCombined, true);
            document.removeEventListener("keyup", handleKey, true);
        };
    }, []);

    // Restore store state when component mounts
    useEffect(() => {
        const restoreStore = async () => {
            setLoading(true);
            try {
                if (!store?.pages?.length) {
                    const savedStore = await getFromIndexedDB(
                        "designs",
                        "polotnoDesignStore"
                    );
                    if (savedStore) {
                        store.loadJSON(savedStore);
                        await store.waitLoading();
                    } else {
                        initialLoadPages();
                    }
                }
            } catch (error) {
                console.error("Error restoring store state:", error);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }
        };

        const boardType = searchParams.get("boardType");

        if (boardType === "new") {
            store.clear();
        }

        if(Object.keys(sizeDimensions).length > 0){
            console.log("call restore store")
            restoreStore();
        }
        else{
            console.log("can't call restore store ", sizeDimensions); 
        }


    }, [sizeDimensions, selectedType, activeTab]);

    const None = () => null;

    const generateSizeDimensions = (sizes) => {
        // Helper function to calculate dimensions
        const calculateDimensions = (inchWidth, inchHeight) => ({
            width: Math.round(parseFloat(inchWidth) * 72),
            height: Math.round(parseFloat(inchHeight) * 72),
            inchWidth,
            inchHeight,
            inch: `${inchWidth} X ${inchHeight} in`,
        });

        // Convert sizes to the required format
        const back = {};
        const halfSleeves = {};
        const fullSleeves = {};

        sizes.forEach((size) => {
            // Back dimensions (from tshirtSizes)
            back[size.label] = {
                ...calculateDimensions(size.width, size.height),
                size: size.size,
            };

            // Half Sleeves dimensions
            halfSleeves[size.label] = {
                ...calculateDimensions(
                    size.halfSleeveWidth,
                    size.halfSleeveHeight
                ),
                size: size.size,
            };

            // Full Sleeves dimensions
            fullSleeves[size.label] = {
                ...calculateDimensions(
                    size.fullSleeveWidth,
                    size.fullSleeveHeight
                ),
                size: size.size,
            };
        });

        return {
            back,
            halfSleeves,
            fullSleeves,
            a4: {
                width: 3600,
                height: 2100,
                size: "a4",
                inchWidth: "18.3",
                inchHeight: "11.7",
                inch: "18.3 x 11.7 in",
            },
        };
    };

    // console.log("store ", store);
    useEffect(()=>{
        setTimeout(scrollToTop, 1000)
    }, [])


  const debouncedRename = useCallback(
    debounce(async (value) => {
      await handleDesignRename(value);
      saveDesign("", "", value); 
    }, 600),
    []
  );

// useEffect(() => {
//     const el = store.selectedElements[0];
  
//     console.log(JSON.stringify(el), "el")
//     if (
//       el &&
//       store.selectedElements.length === 1 &&
//       el.type === "text" &&
//       !el.curveEnabled &&
//       el.custom?.autoFit === true
//     ) {
//       unstable_setTextOverflow("change-font-size", el.id);
//       unstable_setTextOverflow("resize", el.id);
//     }
//   }, [
//     store.selectedElements[0]?.id,
//     store.selectedElements[0]?.text,
//     store.selectedElements[0]?.custom?.autoFit,
//   ]);

// useEffect(() => {
//     const el = store.selectedElements[0];

//     if (!el || el.type !== "text") return;

//     if (isTextOverFlowOn) {
//         unstable_setTextOverflow("resize");
//         unstable_setTextOverflow("change-font-size");
//     }
//     else {
//         unstable_setTextOverflow("resize");
//         // unstable_setTextOverflow(null);
//     }



// }, [isTextOverFlowOn, store.selectedElements[0]?.id]);

// useEffect(() => {
//     const handleSelectionChange = () => {
//         const selected = store.selectedElements[0];

//         if (selected && selected.type === "text") {
//             const isCurved = selected.curveEnabled === true;
//             setIsTextOverFlowOn(!isCurved);
//         }
//     }; const disposer = store.on("change", handleSelectionChange);
//     return () => disposer?.();
// }, [store]);


  
const ensureTextAutoFit = (store) => {
    store.pages.forEach((page) => {
      if (page.custom?.textAutoFitEnabled === undefined) {
        page.set({
          custom: {
            ...(page.custom || {}),
            textAutoFitEnabled: true,
          },
        });
      }
    });
  };
  

 const TextAutoFitToggle = observer(({ store }) => {
    const page = store.activePage;
    if (!page) return null;
  
    const isOn = page.custom?.textAutoFitEnabled ?? true;
  
    return (
      <button
        className="bp5-button bp5-minimal"
        style={{
          color: isOn ? "#2A1FB3" : "black",
          backgroundColor: isOn ? "#E4E2FF" : "white",
        }}
        onClick={() => {
          page.set({
            custom: {
              ...(page.custom || {}),
              textAutoFitEnabled: !isOn,
            },
          });
        }}
        title="Toggle text auto-fit for this page"
      >
        Auto-Fit
      </button>
    );
  });


  useEffect(() => {
    const el = store.selectedElements[0];
    if (!el || el.type !== "text") return;
  
      if (el.curveEnabled === true) {
            unstable_setTextOverflow("ellipsis");
            return;
        }
    const isAutoFitOn =
    store.activePage?.custom?.textAutoFitEnabled === undefined
      ? true
      : store.activePage.custom.textAutoFitEnabled;
      
      
    if (isAutoFitOn) {
      unstable_setTextOverflow("resize");
      unstable_setTextOverflow("change-font-size");
    } else {
        unstable_setTextOverflow("resize");
    }
  }, [
    store.selectedElements[0]?.id,
    store.activePage?.id,
    store.activePage?.custom?.textAutoFitEnabled,
    store.selectedElements[0]?.curveEnabled
  ]);
  
  useEffect(() => {
    const el = store.selectedElements[0];
    const page = store.activePage;
    if (!el || el.type !== "text" || !page) return;
  
    if (el.curveEnabled === true && page.custom?.textAutoFitEnabled !== false) {
      page.set({
        custom: {
          ...(page.custom || {}),
          textAutoFitEnabled: false,
        },
      });
    }
  }, [
    store.selectedElements[0]?.curveEnabled,
    store.activePage?.id,
  ]);
  

    return (
        <>
            {showInformationPopup && (
                <InformationPopup
                    closePopup={() => setInformationPopup(false)}
                    message={"Add Variation first!"}
                />
            )}

            {
                isSizeFetched ? (
                    <PolotnoContainer
                    style={{ width: "100vw", height: "100vh" }}
                    className="polotno-container"
                >
                    <SidePanelWrap className="polotno-sidebar">
                        <Link
                            to="/"
                            className="sidebar-logo"
                            onClick={(e) => {
                                e.preventDefault();
                                window.location.href = "/";
                            }}
                        >
                            <img
                                src={"/assets/images/teedex-logo.png"}
                                alt="Varient logo"
                                className="sidebar-logo-main"
                            />
                            <img
                                src={"/assets/images/teedex-logo-hover.png"}
                                alt="Varient logo"
                                className="sidebar-logo-hover"
                            />
                        </Link>
                        <Sidebar store={store} />
                        <div className="left-main-menu designSidebar">
                            <DesignSidebar />
                        </div>
                    </SidePanelWrap>
                    <WorkspaceWrap className="polotno-workspace">
                        {!showTimeLine && (
                            <>
                                <div
                                    className="artboard--main__header--center"
                                    style={{ position: "relative" }}
                                >
                                    <div className="upgradeButtonFixedHome">
                                        <VariationCountLabel
                                            userPlanDetails={userPlanDetails}
                                        />

                                        <InternetSpeedIndicator />
                                    </div>
                                    <div className="artboard--main__tabs">
                                        <button
                                            className="artboard--main__tabs--nav__item active"
                                        // onClick={navigateHomePage}
                                        >
                                            Design
                                        </button>
                                        <button
                                            className="artboard--main__tabs--nav__item"
                                            onClick={handleVariationClick}
                                            disabled={
                                                redirectingVariation ||
                                                designIsLoading ||
                                                applyingToAll
                                            }
                                        >
                                            {!applyingToAll &&
                                                redirectingVariation ? (
                                                <BeatLoader
                                                    color="#2A1FB3"
                                                    size={8}
                                                />
                                            ) : (
                                                "Variation"
                                            )}
                                            {/* Variation */}
                                        </button>
                                        <button
                                            className="artboard--main__tabs--nav__item"
                                            onClick={handleExportClick}
                                            disabled={
                                                designIsLoading || redirectingExport
                                            }
                                        >
                                            {redirectingExport ? (
                                                <BeatLoader
                                                    color="#2A1FB3"
                                                    size={8}
                                                />
                                            ) : (
                                                "Export"
                                            )}
                                        </button>
                                    </div>
                                </div>
                                {/* <div className="artboard--main__header--right variation-button">
                    <a onClick={handleVariationClick}>
                      <img
                        src={"/assets/images/list_white-icn.svg"}
                        alt="Variation Icon"
                      />
                      Add Variation
                    </a>
                  </div> */}
                                <div className="artboard--main__header--right variation-button">

                                <div className="input-with-icon">

                                <CloudIcon className="icon"/>
                                <input
                                    type="text"
                                    onChange={(e) => {
                                        setDesignName(e.target.value);
                                        debouncedRename(e.target.value);
                                    }}
                                        placeholder="Enter design name"
                                        onKeyDown={async (e) => {
                                            if (e.key === "Enter") {
                                                await handleDesignRename(e.target.value);
                                                saveDesign("", "", designName)
                                            }
                                        }}
                                        value={designName}
                                        name="designFileName"
                                    />
                                </div>
                                    <button className="primary-button save-design-btn"
                                        // onClick={() => {
                                        //   if (id || designInfo?.id) {
                                        //     handleDesignRename()
                                        //   } else {
                                        //     saveDesign()
                                        //   }
                                        // }} 
                                        onClick={() => saveDesign("","",designName)}
                                    >
                                        <img
                                            src={"/assets/images/save_icon.svg"}
                                            alt="Variation Icon"
                                        />
                                        Save
                                    </button>
                                </div>
                            </>
                        )}
                        <Toolbar
                            store={store}
                            components={{
                                TextFontFamily: customFontFamily,
                                TextAiWrite,
                                ImageSetBackgroundButton,
                                ImageStretch,
                                TextTransform: None,
                                TextUpperCase: TextUpperCaseButton,
                                // TextInfo: TextInfo,
                                Position: SizeControls,
                                FigureFitToPage,
                                // TextOverflowToggle: () => (
                                //     <TextOverflowToggle
                                //         isTextOverFlowOn={isTextOverFlowOn}
                                //         setIsTextOverFlowOn={setIsTextOverFlowOn}
                                //         store={store}
                                //     />
                                // )
                                // TextApplyToAllPages: ApplyToAllPages,
                                // ImageApplyToAllPages: ApplyToAllPages,
                                // VideoApplyToAllPages: ApplyToAllPages,
                                // FigureApplyToAllPages: ApplyToAllPages,
                                // GifApplyToAllPages: ApplyToAllPages,
                                // LineApplyToAllPages: ApplyToAllPages,
                                // TextAutoFitToggle: TextAutoFitToggle,
                                TextAutoFitToggle
                            }}
                        />
                        {/* <CustomHeightWidthInfo sizeFormat={sizeFormat} store={store} /> */}
    
                        <Workspace
                            // renderOnlyActivePage={renderOnlyActivePage}
                            store={store}
                            components={{
                                PageControls: ({
                                    store,
                                    page,
                                    xPadding,
                                    yPadding,
                                }) => {
                                    const hasManyPages = store.pages.length > 1;
                                    const index = store.pages.indexOf(page);
                                    return (
                                        <div className="artboard-page-controls">
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: yPadding - 20 + "px",
                                                    left: xPadding + "px",
                                                }}
                                                className="artboard-page"
                                            >
                                                <EditableText
                                                    disabled
                                                    className="artboard-page-name"
                                                    value={
                                                        ([
                                                            "a1",
                                                            "a2",
                                                            "a3",
                                                            "a4",
                                                            "custom",
                                                        ].includes(selectedType)
                                                            ? `${selectedType.toUpperCase()} Master`
                                                            : page.id
                                                                ?.split("_")
                                                                .join(" ")
                                                                ?.toUpperCase()) ||
                                                        "Untitled page"
                                                    }
                                                    onChange={(val) => {
                                                        page.set({
                                                            custom: {
                                                                ...page.custom,
                                                                name: val,
                                                            },
                                                        });
                                                    }}
                                                />
                                                <EditableText
                                                    className="artboard-page-size"
                                                    disabled
                                                    value={page.custom[sizeFormat]}
                                                    onChange={(val) => {
                                                        page.set({
                                                            custom: {
                                                                ...page.custom,
                                                                name: val,
                                                            },
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: yPadding - 30 + "px",
                                                    right: xPadding + "px",
                                                }}
                                                className="artboard-sizes"
                                            >
                                                <select
                                                    value={sizeFormat}
                                                    onChange={sizeChangeHandler}
                                                >
                                                    <option value={"pixels"}>
                                                        Pixels
                                                    </option>
                                                    <option value={"inch"}>
                                                        Inch
                                                    </option>
                                                </select>
                                            </div>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: yPadding - 40 + "px",
                                                    right: xPadding + "px",
                                                }}
                                            ></div>
                                        </div>
                                    );
                                },
                                TextAiWrite,
                                Tooltip: showTooltip ? Tooltip : null,
                                // TextApplyToAllPages: ApplyToAllPages,
                                // ImageApplyToAllPages: ApplyToAllPages,
                                // VideoApplyToAllPages: ApplyToAllPages,
                                // FigureApplyToAllPages: ApplyToAllPages,
                                // GifApplyToAllPages: ApplyToAllPages,
                                // LineApplyToAllPages: ApplyToAllPages,
                            }}
                        />
                        <div className="zoombar">
                            <img
                                src={"/assets/images/zoom_in-icn.svg"}
                                alt="Refresh Icon"
                            />
                            Zoom
                            <CustomeZoombar store={store} />
                        </div>
    
                        {selectedType !== "a4" &&
                            selectedType !== "a3" &&
                            selectedType !== "a2" &&
                            selectedType !== "a1" &&
                            selectedType !== "custom" && (
                                <>
                                    {(!isProcessing && !loading && !isLoading) ||
                                        !showingTimeline ? (
                                        <div id="timeline-container">
                                            {" "}
                                            <PagesTimeline
                                                store={store}
                                                defaultOpened={true}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "40px",
                                                background:
                                                    "rgba(255, 255, 255, 0.8)",
                                                gap: "8px",
                                                marginTop: "20px",
                                            }}
                                        >
                                            <BeatLoader color="#2A1FB3" size={15} />
                                            <span
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#666",
                                                }}
                                            >
                                                Loading Thumbnails...
                                            </span>
                                        </div>
                                    )}
                                </>
                            )}
    
                        <TimeLineControllers
                            timlineHandler={timlineHandler}
                            smallThumbHandler={smallThumbHandler}
                            showTimeline={showTimeLine}
                            showSmallThumbs={showSmallThumbs}
                            refreshHandler={refreshHandler}
                            handleUnlockClick={handleUnlockClick}
                            resetHandler={resetHandlerV2}
                            selectedType={selectedType}
                            isResetting={isResetting}
                            applyAllAlreadyClicked={applyAllAlreadyClicked}
                            warnPopup={warnPopup}
                            setWarnPopup={setWarnPopup}
                            applyingToAll={applyingToAll}
                        />
    
                        {showTimeLine &&
                            selectedType &&
                            selectedType !== "a4" &&
                            selectedType !== "a3" &&
                            selectedType !== "a2" &&
                            selectedType !== "a1" &&
                            selectedType !== "custom" && (
                                <CustomPageTimeline
                                    store={store}
                                    // allThumbs={allThumbs}
                                    allThumbs={images}
                                    handlePageClick={handlePageClick}
                                    currentActivevPage={store.activePage.id}
                                />
                            )}
    
                        {/* </div> */}
                    </WorkspaceWrap>
                </PolotnoContainer>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100vh",
                            width: "100%",
                            gap: "12px",
                        }}
                    >
                        <BeatLoader color="#2A1FB3" size={15} />
                        <span
                            style={{
                                fontSize: "14px",
                                color: "#666",
                            }}
                        >
                            Loading Sizes...
                        </span>
                    </div>
                )
            }



        </>
    );
});

export default PolotnoDesignNew;
